import React, { FC } from 'react';
import styled from 'styled-components';
import { Switch } from 'antd';
interface Props {
  checked: boolean;
  onClick: (checked: boolean, event: MouseEvent) => void;
}

const Styles = styled.div`
  .show-map-label {
    color: ${({ theme }) => theme.greyDarker};
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 12px;
    padding-right: 8px;
    text-transform: uppercase;
  }
`;

export const ShowMap: FC<Props> = ({ checked, onClick }): JSX.Element => {
  return (
    <Styles>
      <span className="show-map-label">Show Map:</span>
      <Switch checked={checked} onClick={onClick} />
    </Styles>
  );
};
